import { User } from "../user/models/User";
import { BaseStore } from "../../utils/BaseStore";

export interface AccountState {
  loggedIn?: boolean;
  user?: User;
  /**
   * Which of the user's companies is currently being viewed. Users may belong
   * to several; this is the one the company and system areas scope to.
   */
  selectedCompanyId?: string;
  loggingIn?: boolean;
  loggingOut?: boolean;
  submittingCredentials?: boolean;
}

export interface AccountActions {
  setSelectedCompany(companyId: string): void;
  setSubmittingCredentials(submitting: boolean): any;
  setLoggingIn(state: boolean);
  setLoggingOut(state: boolean);
  logout(): void;
  login(user: User): void;
}

export class AccountStore
  extends BaseStore<AccountState, AccountActions>
  implements AccountActions
{
  protected prototype = AccountStore.prototype;
  protected initialState = {
    loggedIn: false,
    loggingOut: false,
    user: undefined,
    selectedCompanyId: undefined,
    loggingIn: false,
    submittingCredentials: false,
  };

  constructor() {
    super();
  }

  public login(user: User) {
    this.setState({
      loggedIn: user != undefined,
      loggingIn: false,
      loggingOut: false,
      user,
      // default to the user's first company; a switcher can change it later
      selectedCompanyId: user?.getCompanyIds()[0],
    });
  }

  public setSelectedCompany(companyId: string) {
    this.setState({
      ...this.state,
      selectedCompanyId: companyId,
    });
  }

  public logout() {
    this.setState({
      loggedIn: false,
      user: undefined,
      selectedCompanyId: undefined,
      loggingIn: false,
      loggingOut: false,
    });
  }

  public setLoggingIn(state: boolean) {
    this.setState({
      ...this.state,
      loggingIn: state,
      loggingOut: false,
    });
  }

  public setLoggingOut(state: boolean) {
    this.setState({
      ...this.state,
      loggingIn: false,
      loggingOut: state,
    });
  }

  public setSubmittingCredentials(state: boolean) {
    this.setState({
      ...this.state,
      submittingCredentials: state,
    });
  }
}
